/**
 * The one place that turns a Blob into a download. Replaces three near-identical copies of the
 * anchor-click dance, each of which got the object URL lifecycle slightly wrong.
 */
export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Deferred on purpose: revoking synchronously after click() races the download in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 0);
};
